// DS: i3.18
import React from 'react';
import IconWrap from '../../IconWrap';
const Send = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M20.933 3.684a1 1 0 010 .632l-5.415 16.246a.618.618 0 01-1.023.242l-.574-.574a1 1 0 01-.209-.306l-2.504-5.733 3.994-3.994a1 1 0 00.078-1.327l-.078-.087a1 1 0 00-1.327-.078l-.087.078-3.994 3.994-5.733-2.504a1 1 0 01-.307-.21l-.573-.573a.618.618 0 01.242-1.023l16.245-5.415a1 1 0 011.265.632z"
    })));
Send.displayName = 'Send';
export default Send;

//# sourceMappingURL=Send.js.map